import { render, staticRenderFns } from "./otherMessage.vue?vue&type=template&id=b59b9db6&scoped=true"
import script from "./otherMessage.vue?vue&type=script&lang=js"
export * from "./otherMessage.vue?vue&type=script&lang=js"
import style0 from "./otherMessage.vue?vue&type=style&index=0&id=b59b9db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59b9db6",
  null
  
)

export default component.exports